<template>
  <div
    id="commonHeader"
    class="h-41px flex justify-between items-center  border-b-1px border-solid border-[#e6e6e6]"
  >
    <div class="flex-1 truncate flex items-center text-16px font-bold text-[#333333]">
      <div class="inline-block w-3px h-18px bg-[#D41819] rounded-1px mr-7px ml-4px"></div>
      {{ title }}
    </div>
    <div
      class="text-[#999999] text-12px cursor-pointer truncate pr-15px"
      @click="loadMore"
      v-if="showMore"
    >
      更多
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColumnHeader',
  props: {
    title: {
      type: String,
      default: '新闻',
    },
    showMore: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    loadMore() {
      this.$emit('loadMore')
    },
  },
}
</script>

<style scoped lang="scss">
.microsoftYaHei {
  font-family: 'Microsoft YaHei regular';
}
</style>
